import { render, staticRenderFns } from "./TipTapMenu.vue?vue&type=template&id=86bc8954&scoped=true&"
import script from "./TipTapMenu.vue?vue&type=script&lang=js&"
export * from "./TipTapMenu.vue?vue&type=script&lang=js&"
import style0 from "./TipTapMenu.vue?vue&type=style&index=0&id=86bc8954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bc8954",
  null
  
)

export default component.exports